import { PathMarker } from './path-marker';
import { PathPointBbx } from '../path-point/path-point-bbx';

export class PathMarkerBbx extends PathMarker {
  public override pathPoint: PathPointBbx;
}
